import {
  ClassAndSubjectPopup,
  getDeviceType,
  pxToRem,
  pxTovW,
  SecondaryButton,
  SecondaryOutlinedButton,
  theme,
  IClassAndSubjectSelected,
} from '@geneo2-web/shared-ui';
import {
  useAppDispatch,
  useAppSelector,
} from 'apps/teacher/src/reduxStore/reduxHooks';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { subjectsWithClass } from 'apps/teacher/src/utils/icons';
import { useState } from 'react';
import { interactionEvent } from '../../Auth/auth.events';
import CloseIcon from '@mui/icons-material/Close';
import { setClassAndSubjectInfo } from '../../Home/reducer/homeDashboard.slice';
import { useDownloadContext } from 'apps/teacher/src/app/Context/DownloadContextProviderV2';
import { useGlobalContext } from 'apps/teacher/src/app/Context/GlobalContextProvider';
import { TeachClassSubjects } from '@protos/user_management/ums.login.apis_pb';

const ClassAndSubjectPicker = ({
  interactionEventContext,
  onClassSubjectClick,
  teacherClassSubjects,
}: IProps) => {
  const { class_subject_info } = useAppSelector((state) => state.homeDashboard);
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { isIpadOnly } = useGlobalContext();
  const deviceType = getDeviceType();
  const android = window.Android;
  const dispatch = useAppDispatch();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  /** States */
  const [modalState, setModalState] = useState(false);

  const classAndsubjectClickHandler = async (
    inputClassInfo: IClassAndSubjectSelected
  ) => {
    dispatch(setClassAndSubjectInfo(inputClassInfo));
    setModalState(false);
    onClassSubjectClick?.();
    await interactionEvent({
      context: 'Choose_Class_&_Subject',
      name: inputClassInfo.subject.trim().toUpperCase().replace(/\s+/g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  return (
    <>
      <Box
        onClick={(e) => {
          setModalState(true);
          try {
            if (deviceType === 'android' && android?.disableAppRefresh) {
              console.log('App refresh disabled on Android for home page');
              android.disableAppRefresh();
            }
          } catch (error) {
            console.log(
              'An error occurred while attempting to enable app refresh on Android:'
            );
          }
        }}
        sx={{ flex: { xs: 1, md: 'unset' } }}
      >
        {largeScreen ? (
          <SecondaryOutlinedButton
            size={isIpadOnly ? 'large' : 'medium'}
            witharrow={class_subject_info ? false : true}
            onClick={async () => {
              await interactionEvent({
                context: interactionEventContext,
                name: 'CHOOSE_CLASS_SUBJECT',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
          >
            {class_subject_info && class_subject_info.classname ? (
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography variant="h4">{`${class_subject_info?.classname} ${class_subject_info?.section} - ${class_subject_info?.subject}`}</Typography>
                <CloseIcon
                  sx={{
                    color: 'common.black',
                    fontSize: { xs: pxToRem(14), md: pxToRem(17), lg: pxTovW(18) },
                  }}
                  onClick={(ev) => {
                    ev.stopPropagation();
                    dispatch(setClassAndSubjectInfo(undefined));
                    onClassSubjectClick?.();
                  }}
                />
              </Box>
            ) : (
              <Typography variant="h4">Choose Class & Subject</Typography>
            )}
          </SecondaryOutlinedButton>
        ) : (
          <SecondaryButton
            witharrow
            onClick={async () => {
              await interactionEvent({
                context: interactionEventContext,
                name: 'CHOOSE_CLASS_SUBJECT',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
          >
            <Typography variant="h5" fontWeight="bold" color="white">
              {class_subject_info
                ? `${class_subject_info.classname}${class_subject_info.section}-${class_subject_info.subject}`
                : 'Choose Class & Subject'}
            </Typography>
          </SecondaryButton>
        )}
      </Box>

      <ClassAndSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={subjectsWithClass}
        classSubjectsList={teacherClassSubjects}
        classAndsubjectClickHandler={classAndsubjectClickHandler}
      />
    </>
  );
};

export default ClassAndSubjectPicker;

interface IProps {
  interactionEventContext: string;
  onClassSubjectClick: () => void;
  teacherClassSubjects: TeachClassSubjects[];
}
